import script from "./MoneyFormat.vue?vue&type=script&setup=true&lang=js"
export * from "./MoneyFormat.vue?vue&type=script&setup=true&lang=js"

import "./MoneyFormat.vue?vue&type=style&index=0&id=58581a91&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58581a91"]])

export default __exports__